module.exports = __webpack_public_path__ + "img/hub.9c44c512.svg";